import { render } from "./LegalTermsDashboard.vue?vue&type=template&id=3245dd20&scoped=true"
import script from "./LegalTermsDashboard.vue?vue&type=script&lang=js"
export * from "./LegalTermsDashboard.vue?vue&type=script&lang=js"

import "./LegalTermsDashboard.vue?vue&type=style&index=0&id=3245dd20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3245dd20"]])

export default __exports__